import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../constants/path';
import { STATIC_ROOT } from '../../../../constants';
import SvgComponent from '../../../SvgComponent';

import { validateMerchantSession, authorizePayment } from '../../../../services/applepay/utils';

import { ButtonWrapper } from './style';

const ApplePayButton = ({ userInfo, partnerId, order, cartTotalValue, ebon }) => {
    const [canMakePayments, setCanMakePayments] = useState(false);

    useEffect(() => {
        const checkApplePayAvailability = async () => {
            if (window.ApplePaySession && window.ApplePaySession.canMakePayments) {
                try {
                    const isAvailable = await window.ApplePaySession.canMakePayments();
                    setCanMakePayments(isAvailable);
                } catch (error) {
                    console.error('Error while verifying if Apple Pay is available :', error);
                    setCanMakePayments(false);
                }
            }
        };

        checkApplePayAvailability();
    }, []);

    const processApplePayment = async () => {
        if (window.ApplePaySession) {
            const session = new window.ApplePaySession(6, {
                countryCode: 'FR',
                currencyCode: 'EUR',
                merchantCapabilities: ['supports3DS'],
                supportedNetworks: ['visa', 'masterCard'],
                total: {
                    label: ebon,
                    type: 'final',
                    amount: cartTotalValue.toString()
                }
            });
            session.onvalidatemerchant = async event => {
                try {
                    const merchantSession = await validateMerchantSession(event.validationURL);
                    if (!merchantSession) {
                        console.error('Invalid Apple Pay merchant session');
                    }
                    session.completeMerchantValidation(merchantSession);
                } catch (error) {
                    console.error('merchant validation error : ', error);
                    session.abort();
                }
            };
            session.onpaymentauthorized = async event => {
                try {
                    const link = await authorizePayment(
                        event.payment.token,
                        userInfo,
                        partnerId,
                        order.id
                    );
                    window.location.href = link;
                } catch (error) {
                    console.error('Apple Payment authorization error : ', error);
                    const errorUrl = `${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error&orderId=${order.id}`;
                    window.location.href = errorUrl;
                }
            };
            session.oncancel = event => console.log('Apple Pay cancel event : ', event);
            session.begin();
        }
    };

    if (!canMakePayments) return null;

    return (
        <React.Fragment>
            <ButtonWrapper onClick={processApplePayment}>
                <SvgComponent
                    src={`${STATIC_ROOT}/payment/apple-pay-logo.svg`}
                    width={56}
                    height={23}
                />
            </ButtonWrapper>
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        ebon: state.i18n.common.EBON
    };
};

export default connect(mapStateToProps)(ApplePayButton);



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/ApplePayButton/index.js